export function queryData(view = "key for properties") {
  // console.log(view.id, view.location, view.plantsSubset);
  return fetch(`/queryData?&id=${view.id}&locationText=${view.locationText}`)
    .then((r) => r.json())
    .then((data) => {
      return data;
    });
}
